import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=71480830&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"
import style0 from "./Employee.vue?vue&type=style&index=0&id=71480830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71480830",
  null
  
)

export default component.exports